<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <feed-mixer-field-form-group
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></feed-mixer-field-form-group>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <feed-mixer-sample-form-group
          v-for="(sample, index) in submission_data.samples"
          :key="index"
          :index="index"
          :sample="sample"
          :sampleListLength="submission_data.samples.length"
          @onSampleListChange="onSampleListChange"
        ></feed-mixer-sample-form-group>
      </div>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <b-row align-h="end">
        <b-col cols="4">
          <b-button
            variant="success"
            block
            @click="onSampleListChange({ action: 'add' })"
            ><i class="fa fa-plus"></i> Add sample</b-button
          >
        </b-col>
      </b-row>
      <b-button variant="danger" @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import FeedMixerFieldFormGroup from "./FeedMixerFieldFormGroup";
import FeedMixerSampleFormGroup from "./FeedMixerSampleFormGroup";
import TurnAroundSelect from "../../TurnAroundSelect";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
export default {
  name: "FeedMixerForm",
  components: {
    FeedMixerFieldFormGroup,
    FeedMixerSampleFormGroup,
    TurnAroundSelect
  },
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.submission_data.submission_feed_mixer_efficiency.all_sample_types =
          data.all_sample_types;
        this.submission_data.samples = this.submission_data.samples.map(
          sample => {
            return {
              ...sample,
              sample_feed_mixer_efficiency: {
                type: data.all_sample_types
              }
            };
          }
        );
        this.emitSubmissionChange();
      }
    },
    onSampleListChange({ action, sample_index }) {
      let sampleListUpdate;
      switch (action) {
        case "add":
          sampleListUpdate = [
            ...this.submission_data.samples,
            {
              ...this.submission_data.samples[0],
              test_package_sample_id: this.$uuid.v4()
            }
          ];
          break;
        case "remove": {
          sampleListUpdate = [...this.submission_data.samples].filter(
            (sample, index) => index !== sample_index
          );
          break;
        }
        default:
      }
      this.submission_data.samples = sampleListUpdate.map((sample, index) => {
        return {
          ...sample,
          identifier: `Sample ${index + 1}`
        };
      });
      this.emitSubmissionChange();
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    }
  },
  watch: {
    form: {
      handler(value) {
        this.onFieldChange(value);
      },
      deep: true,
      immediate: true
    },
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  beforeMount() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
